import { AxiosResponse } from 'axios';
import { LoginCredentials, User } from '../../types';
import apiClient from '../api/client';
import { delay } from '../mock/delay';
import { mockUsers } from '../mock/users';

// Auth response type
export interface AuthResponse {
  success: boolean;
  data: {
    refresh: string;
    access: string;
  };
}

export const authService = {
  // Admin medical facility login - POST /api/auth/login/
  login: async (credentials: LoginCredentials): Promise<AxiosResponse<AuthResponse>> => {
    return apiClient.post<LoginCredentials, AxiosResponse>('/auth/login/', credentials);
  },

  // Admin login - POST /api/auth/login-admin/
  loginAdmin: async (credentials: LoginCredentials): Promise<AxiosResponse<AuthResponse>> => {
    // await delay(800);
    // const user = mockUsers.find((u) => u.username === credentials.username && u.role === 'admin');
    // if (user && credentials.password === 'password') {
    //   return {
    //     success: true,
    //     data: {
    //       refresh: 'mock-refresh-token-admin-' + user.id,
    //       access: 'mock-access-token-admin-' + user.id,
    //     },
    //   };
    // }
    // throw new Error('Invalid credentials');
    return apiClient.post<LoginCredentials, AxiosResponse>('/auth/admin/login/', credentials);
  },

  // Get current user info - GET /api/v1/users/me/ with Bearer token
  getCurrentUser: async (accessToken: string): Promise<AxiosResponse<{ success: boolean; data: User }>> => {
    return apiClient.get<string, AxiosResponse<{ success: boolean; data: User }>>('/users/me/', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },
};

